import { useTranslation } from 'react-i18next';
import { notification } from 'antd';

const useErrorMessage = () => {
  const { t } = useTranslation();
  return {
    message: (status, duration = 5.5) => {
      const s = status?.response?.status || status;
      if (s !== 498)
        notification.error({
          title: t(`errors.message.${s}`),
          key: 'network_feedback',
          duration
        });
    }
  };
};

export default useErrorMessage;
